import { Button, Icons } from '@120wateraudit/envirio-components'
import React from 'react'
import { Menu, Sidebar } from 'semantic-ui-react'
import styled from 'styled-components'

import useAccount from 'hooks/useAccount'
import { PROGRAM_DESCRIPTION } from 'utils/constants'

interface Props {
  visible: boolean
  setVisible(visible: boolean): void
}

const AppSidebar = ({ setVisible, visible }: Props) => {
  const { accountName, description, contactLinkURL } = useAccount()
  return (
    <Sidebar
      animation="overlay"
      as={Menu}
      icon="labeled"
      inverted
      onHide={() => setVisible(false)}
      style={{ background: 'white' }}
      vertical
      visible={visible}
      width="very wide">
      <IconWrapper>
        <Button
          onClick={() => setVisible(false)}
          size="small"
          style={{ cursor: 'pointer', background: 'none' }}>
          <Icons.Close />
        </Button>
      </IconWrapper>
      <SidebarHeader>About this Program</SidebarHeader>
      <Description>{description || PROGRAM_DESCRIPTION}</Description>
      <SidebarHeader>About this Resource</SidebarHeader>
      <Description>
        {`The resources have been made available by ${accountName} and its
      commitment to safe drinking water. Please`}{' '}
        {contactLinkURL ? (
          <a href={contactLinkURL} rel="noreferrer noopener" target="_blank">
            {`contact ${accountName}`}
          </a>
        ) : (
          <a
            href="https://120water.com/support/"
            rel="noreferrer noopener"
            target="_blank">
            contact 120Water
          </a>
        )}{' '}
        for any questions.
      </Description>
      <SidebarHeader>Disclaimer</SidebarHeader>
      <Description>
        {`The information provided by 120Water and ${accountName} shall be
      used for the purpose of providing property owners and residents
      information regarding their water services. The data is not
      for commercial, legal, or other use.`}
      </Description>
      <Description>
        {`120Water and ${accountName} cannot guarantee the accuracy of
      these maps and is not liable for damages of any kind, including but
      not limited to lost business, lost profits, business interruption,
      data loss, or other loss that might arise from using this mapping
      resource and information. 120Water and ${accountName} reserves the
      right to update or terminate the display of these maps and records
      at any time.`}
      </Description>
      <Button onClick={() => setVisible(false)} style={{ marginTop: '2rem' }}>
        Close
      </Button>
    </Sidebar>
  )
}

const SidebarHeader = styled.h6`
  text-align: start;
  padding-left: 20px;
`

const Description = styled.p`
  text-align: start;
  padding-left: 20px;
  padding-right: 20px;
  white-space: pre-line;
`

const IconWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`

export default AppSidebar
